import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "rightWrap"
};
const _hoisted_2 = {
  class: "titlebox"
};
const _hoisted_3 = {
  class: "contentwrap"
};
const _hoisted_4 = {
  class: "picList"
};
const _hoisted_5 = ["onDragstart"];
const _hoisted_6 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($data.detail.title) + "样式管理", 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.picList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      draggable: "true",
      onDragstart: $event => $options.decorationDragStart($event, item)
    }, [_createElementVNode("img", {
      src: $options.setImg(item.itemformdata.picture_upload[0]),
      alt: ""
    }, null, 8, _hoisted_6), _cache[0] || (_cache[0] = _createElementVNode("i", {
      class: "icon-right"
    }, null, -1))], 40, _hoisted_5);
  }), 128))])])], 512)), [[_vShow, $data.rightShow]]);
}